const vanityRoutes = [
  {
    path: "/BRETT",
    redirect:
      "/landing-page/homeschool?couponCode=BRETT35&utm_medium=ads&utm_source=paid_podcast&utm_campaign=paid-podcast-BrettCooper",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/NOMADIC",
    redirect:
      "/online-classes/popular?couponCode=NOMADIC20&utm_medium=paid-influencer&utm_source=youtube&utm_campaign=paid-influencer-NomadicMovement",
    isTranslated: true
  },
  {
    path: "/AE",
    redirect:
      "/online-classes/popular?couponCode=AE&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-AnnieElise",
    isTranslated: true
  },
  {
    path: "/UNPLANNED",
    redirect:
      "online-classes/popular?couponCode=UNPLANNED&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-UnplannedPodcast",
    isTranslated: true
  },
  {
    path: "/PAKMAN",
    redirect:
      "online-classes/popular?couponCode=PAKMAN&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-Pakman",
    isTranslated: true
  },
  {
    path: "/HUMANS",
    redirect:
      "online-classes/humans?couponCode=HUMANS&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-RaisingGoodHumans",
    isTranslated: true
  },
  {
    path: "/LEGENDS",
    redirect:
      "online-classes/legends?couponCode=LEGENDS&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-MythandLegends",
    isTranslated: true
  },
  {
    path: "/CREEPY",
    redirect:
      "online-classes/creepy?couponCode=CREEPY&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-Sinisterhood",
    isTranslated: true
  },
  {
    path: "/STOLEN",
    redirect:
      "online-classes/stolen?couponCode=STOLEN&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-StolenLivesTrueCrime",
    isTranslated: true
  },
  {
    path: "/GHOST",
    redirect:
      "online-classes/ghost?couponCode=GHOST&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-RealGhostStoriesOnline",
    isTranslated: true
  },
  {
    path: "/MOMDAD",
    redirect:
      "online-classes/momdad?couponCode=MOMDAD&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-YourMomandDad",
    isTranslated: true
  },
  {
    path: "/TUTORHELP",
    redirect:
      "tutoring?couponCode=TUTORING20&utm_medium=paid-newsletter&utm_source=newsletter&utm_campaign=paid-newsletter-PeachJar",
    isTranslated: true
  },
  {
    path: "/CAMPS",
    redirect:
      "online-classes/spring-camps?couponCode=CAMPS20&utm_medium=paid-newsletter&utm_source=newsletter&utm_campaign=paid-newsletter-PeachJar",
    isTranslated: true
  },
  {
    path: "/SUMMERCAMP",
    redirect:
      "online-classes/summer-camps?couponCode=CAMPS20&utm_medium=paid-newsletter&utm_source=newsletter&utm_campaign=paid-newsletter-PeachJar",
    isTranslated: true
  },
  {
    path: "/WARROOM",
    redirect:
      "online-classes/popular?couponCode=WARROOM&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-PoliticsWarroom",
    isTranslated: true
  },
  {
    path: "/PAIGEKOSER",
    redirect:
      "/landing-page/courses?couponCode=KOSER20&utm_medium=paid-influencer&utm_source=instagram&utm_campaign=paid-influencer-PaigeKoser",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/KAMRY",
    redirect:
      "online-classes/popular?couponCode=KAMRY20&utm_medium=paid-influencer&utm_source=instagram&utm_campaign=paid-influencer-KamryVincent",
    isTranslated: true
  },
  {
    path: "/LITTLEFENDERS",
    redirect:
      "join-membership?couponCode=START20&utm_medium=paid-influencer&utm_source=instagram&utm_campaign=paid-influencer-LittleFenders",
    isTranslated: true
  },
  {
    path: "/TWINS",
    redirect:
      "join-membership?couponCode=START20&utm_medium=paid-influencer&utm_source=instagram&utm_campaign=paid-influencer-TwinsbytheBeach",
    isTranslated: true
  },
  {
    path: "/EMMASEA",
    redirect:
      "join-membership?couponCode=START20&utm_medium=paid-influencer&utm_source=tiktok&utm_campaign=paid-influencer-emmaseabourn",
    isTranslated: true
  },
  {
    path: "/CHELSEA",
    redirect:
      "/landing-page/courses?couponCode=CHELSEA&utm_medium=paid-influencer&utm_source=instagram&utm_campaign=paid-influencer-ChelseaDyanTuran",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/TWINSBYTHEBEACH",
    redirect:
      "/landing-page/courses?couponCode=TWINS20&utm_medium=paid-influencer&utm_source=tiktok&utm_campaign=paid-influencer-TwinsbytheBeach",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/ANGELROSE",
    redirect:
      "/landing-page/courses?couponCode=ANGELROSE&utm_medium=paid-influencer&utm_source=instagram&utm_campaign=paid-influencer-AngleRoseTurner",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/HAPPYCARAVAN",
    redirect:
      "/landing-page/courses?couponCode=HAPPYCARAVAN&utm_medium=paid-influencer&utm_source=instagram&utm_campaign=paid-influencer-HappyCaravan",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/BETH",
    redirect:
      "/landing-page/homeschool?couponCode=BETH30&utm_medium=paid-influencer&utm_source=tiktok&utm_campaign=paid-influencer-BethGriffin",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/MARYHANNA",
    redirect:
      "/landing-page/homeschool?couponCode=MARYHANNA30&utm_medium=paid-influencer&utm_source=tiktok&utm_campaign=paid-influencer-MaryHannaWilson",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/ROOTS",
    redirect:
      "/landing-page/homeschool?couponCode=KAYCEE30&utm_medium=paid-influencer&utm_source=tiktok&utm_campaign=paid-influencer-rootsacademyhs",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/TERESA",
    redirect:
      "/landing-page/homeschool?couponCode=TERESA30&utm_medium=paid-influencer&utm_source=tiktok&utm_campaign=paid-influencer-TeresaAndLittles",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/ANDREA",
    redirect:
      "/landing-page/homeschool?couponCode=ANDREA30&utm_medium=paid-influencer&utm_source=tiktok&utm_campaign=paid-influencer-LittleRedSchoolhouse",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/GRACE",
    redirect:
      "/landing-page/homeschool?couponCode=GRACE30&utm_medium=paid-influencer&utm_source=tiktok&utm_campaign=paid-influencer-homeschoolingforall",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/RAVEN",
    redirect:
      "/landing-page/courses?couponCode=RAVEN20&utm_medium=paid-influencer&utm_source=instagram&utm_campaign=paid-influencer-RavenKramer",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/DMA",
    redirect:
      "/landing-page/courses?couponCode=DMA&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-DMA",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/WCN",
    redirect:
      "/landing-page/courses?couponCode=WCN&utm_medium=paid-podcast&utm_source=podcast&utm_campaign=paid-podcast-WCN",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/MADRE",
    redirect:
      "/landing-page/homeschool?couponCode=MADRE30&utm_medium=ads&utm_source=paid-influencer&utm_campaign=paid-influencer-MindfulMadre",
    isTranslated: true,
    isExternal: true
  },
  {
    path: "/LEAFANDLEARN",
    redirect:
      "/landing-page/courses?couponCode=LEAFANDLEARN&utm_medium=ads&utm_source=paid_influencer&utm_campaign=paid-influencer-LeafandLearn",
    isTranslated: true,
    isExternal: true
  }
];

export default vanityRoutes;
